<div [class]="maskStyleClass" [ngClass]="getMaskClass()" *ngIf="maskVisible">
  <div
    [ngClass]="{ 'confirm-dialog p-component': true }"
    [ngStyle]="style"
    [class]="styleClass"
    [@animation]="{ value: 'visible', params: { transform: transformOptions, transition: transitionOptions } }"
    (@animation.start)="onAnimationStart($event)"
    (@animation.done)="onAnimationEnd($event)"
    *ngIf="visible"
  >
    <div class="confirm-dialog-header">
      <span class="confirm-dialog-title" *ngIf="title">{{ title }}</span>
      <div class="confirm-dialog-header-icons">
        <button
          *ngIf="closable"
          type="button"
          [ngClass]="{ 'confirm-dialog-header-icon confirm-dialog-header-close p-link': true }"
          (click)="close($event)"
          (keydown.enter)="close($event)"
        >
          <span class="pi pi-times"></span>
        </button>
      </div>
    </div>

    <div #content class="confirm-dialog-content">
      <i [ngClass]="'confirm-dialog-icon'" [class]="icon" *ngIf="icon"></i>
      <span class="confirm-dialog-message" [innerHTML]="message"></span>
    </div>

    <div class="confirm-dialog-footer">
      <p-toolbar styleClass="dialog-toolbar mt-4">
        <div class="p-toolbar-group-left">
          <button
            type="button"
            pRipple
            pButton
            [icon]="cancelIcon"
            [label]="cancelLabel"
            (click)="cancelClick()"
            [ngClass]="'confirm-dialog-reject'"
            [class]="cancelButtonStyleClass"
            *ngIf="cancelVisible"
          ></button>
        </div>

        <div class="p-toolbar-group-right">
          <button
            type="button"
            pRipple
            pButton
            [icon]="acceptIcon"
            [label]="acceptLabel"
            (click)="acceptClick()"
            [ngClass]="'confirm-dialog-accept'"
            [class]="acceptButtonStyleClass"
            *ngIf="acceptVisible"
          ></button>

          <button
            type="button"
            pRipple
            pButton
            [icon]="rejectIcon"
            [label]="rejectLabel"
            (click)="rejectClick()"
            [ngClass]="'confirm-dialog-reject'"
            [class]="rejectButtonStyleClass"
            *ngIf="rejectVisible"
          ></button>
        </div>
      </p-toolbar>
    </div>
  </div>
</div>
